module.exports = __webpack_public_path__ + "img/birthday.0b4f793a.png";